import { Box, Flex } from "@chakra-ui/react";
import { LuReplace } from 'react-icons/lu';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';

export default function RemoveOverviewVideoConfirmationModal({
  handleCloseModal,
  handleRemoveVideoOverviewPage
}) {

  const handleClickCtaButton = () => {
    handleRemoveVideoOverviewPage('removeLoomWelcomeVideo', "")
    handleCloseModal()
  }

  return (
    <LaunchdeckModal
      title='Record & replace video'
      handleCloseModal={handleCloseModal}
      showModal={true}
      maxW='35em'
    >

      <Flex w='100%' justify='center' align='center' p='1em' height='50vh' direction='column'>
        <Box as={LuReplace} mb='2em' boxSize='4em' />

        <Box alignSelf="stretch"
          color='brandDark.500'
          textAlign='center'
          fontWeight='400'
          lineHeight='1.5em'
          fontSize='0.875em'
          mb='1em'>
          Remove this video and record a new one?
        </Box>

        <LaunchdeckButton
          bg='brand.500' color='white'
          onClick={() => handleClickCtaButton()}
          label='Remove video' />
      </Flex>
    </LaunchdeckModal>

  )
}